import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useGetTrackByFrameSeqQuery } from '@/hook';
import { useTaskFrameStore, useTrackIDChangeRequestStore } from '@/store';

export const useTrackIDChangeRequestBootstrap = () => {
  const currentTaskID = useTaskFrameStore(state => state.currentFrame?.taskID);
  const location = useLocation();
  const navigate = useNavigate();
  const requestTrackID = useTrackIDChangeRequestStore(
    state => state.targetTrackID,
  );
  const setLinkedFrameList = useTrackIDChangeRequestStore(
    state => state.setLinkedFrameList,
  );
  const setRequest = useTrackIDChangeRequestStore(state => state.setRequest);
  const { data: linkedFrameList } = useGetTrackByFrameSeqQuery({
    taskID: currentTaskID,
    trackID: requestTrackID ?? undefined,
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const nextTrackID = searchParams.get('newTrackID');
    const requestUserID = searchParams.get('requestUserID');
    const targetTrackID = searchParams.get('trackID');

    if (!nextTrackID || !requestUserID || !targetTrackID) {
      return;
    }

    setRequest({
      nextTrackID,
      requestUserID,
      targetTrackID,
    });

    searchParams.delete('newTrackID');
    searchParams.delete('requestUserID');
    searchParams.delete('trackID');

    const queryString = `${searchParams}`;

    navigate(`${location.pathname}${queryString ? `?${queryString}` : ''}`, {
      replace: true,
    });
  }, [location.pathname, location.search, navigate, setRequest]);

  useEffect(() => {
    if (linkedFrameList == null) {
      return;
    }

    setLinkedFrameList(linkedFrameList);
  }, [linkedFrameList, setLinkedFrameList]);
};
